import { createContext, useContext } from 'react';
import type { Coupon } from '@mypoz/shared';

export interface CouponsState {
  /** Sorted usable-first — see `sortCoupons` in @mypoz/shared. Empty while loading and on error. */
  readonly coupons: readonly Coupon[];
  readonly status: 'loading' | 'ready' | 'error';
  /** Asks the vendor again. Safe to call at any time; a fetch already in flight is discarded. */
  reload: () => void;
}

export const CouponsContext = createContext<CouponsState | null>(null);

export function useCoupons(): CouponsState {
  const value = useContext(CouponsContext);
  if (!value) throw new Error('useCoupons must be used inside CouponsProvider');
  return value;
}
